import { API_BASE } from "@/config/links";

const METRIKA_COUNTER_ID = 110850831;

function reachGoal(goal) {
  if (typeof window === "undefined" || typeof window.ym !== "function") return;
  window.ym(METRIKA_COUNTER_ID, "reachGoal", goal);
}

const TRACKED_QUERY_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "yclid",
  "source",
  "source_type",
  "position_type",
  "position",
  "block",
  "ad_id",
  "campaign_id",
  "phrase_id",
  "keyword",
  "gbid",
  "device_type",
  "device",
  "region_id",
  "region_name",
  "retargeting_id",
  "placement",
];

function safeValue(value, max = 220) {
  return String(value || "").trim().slice(0, max);
}

function landingPayload(extra = {}) {
  if (typeof window === "undefined") return extra;

  const params = new URLSearchParams(window.location.search);
  const query = {};
  for (const key of TRACKED_QUERY_KEYS) {
    const value = params.get(key);
    if (value) query[key] = safeValue(value);
  }

  let referrerHost = "";
  try {
    referrerHost = document.referrer ? new URL(document.referrer).host : "";
  } catch {
    referrerHost = "";
  }

  return {
    ...query,
    ...extra,
    path: safeValue(window.location.pathname, 120),
    referrerHost: safeValue(referrerHost, 120),
    userAgent: safeValue(navigator.userAgent, 260),
  };
}

function sendEvent(path, payload) {
  const url = `${API_BASE}${path}`;
  const body = JSON.stringify(payload);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }));
  } else {
    fetch(url, { method: "POST", body, keepalive: true }).catch(() => {});
  }
}

export function trackVisit() {
  reachGoal("landing_visit");
  sendEvent("/webhooks/landing-visit", landingPayload());
}

// Допустимые цели клика: bot — MAX-бот, channel — MAX-канал, chat — чат на сайте (/chat).
export const CLICK_TARGETS = ["bot", "channel", "chat"];

export function trackClick(target) {
  reachGoal(`landing_click_${target}`);
  sendEvent("/webhooks/landing-click", landingPayload({ target }));
}
